package modals

import apiclient.geoobjects.ObjectType
import auth.ApiUserStore
import data.objects.ActiveObjectStore
import dev.fritz2.core.Store
import koin.withKoin
import kotlinx.coroutines.flow.map
import localization.TL
import localization.translate
import mainmenu.RouterStore
import model.ScannedCode
import model.type
import qrcode.ScannedCodeStore
import theme.FormationIcons
import twcomponents.twPrimaryButton
import twcomponents.twSimpleModalWithCloseHeader
import twcomponents.twSubtitle
import utils.getIcon

fun twCreateTrackedObjectModal(
    toggleShowModalStore: Store<Boolean>,
    // add parameter you need inside the modal here
) {

    withKoin {
        val apiUserStore: ApiUserStore = get()
        val scannedCodeStore: ScannedCodeStore = get()
        val activeObjectStore: ActiveObjectStore = get()
        val routerStore: RouterStore = get()
        val scannedCode = scannedCodeStore.data.map { it.extOrIntObjIdOrActionId ?: it.fallback ?: "" }
        val codeIcon = scannedCodeStore.map(ScannedCode.type()).data.map { it?.getIcon() }

        twSimpleModalWithCloseHeader(
            title = TL.CodeScanning.CODE_ENTERED,
            icon = FormationIcons.QRCode,
            toggleStore = toggleShowModalStore,
            closeHandlers = listOfNotNull(scannedCodeStore.reset),
        ) { closeModal, _, optionalCloseHandlers ->
            div(
                baseClass = "flex flex-col gap-3 w-full md:min-w-96 overflow-y-auto p-2",
                id = "template-modal",
            ) {
                // box for scrollable content
                div(
                    "flex flex-col w-full md:w-96 px-2 max-h-max gap-4 overflow-y-auto",
                ) {
                    div("flex w-full text-center font-bold flex-wrap break-all") {
                        scannedCode.renderText(into = this)
                    }
                    twSubtitle {
                        translate(TL.AlertNotifications.SCANNED_OBJECT_NOT_FOUND)
                    }

                    if (!apiUserStore.current.isAnonymous) {
                        twSubtitle {
                            translate(TL.CodeScanning.CREATE_OBJECT_QUESTION)
                        }
                    } else {
                        twSubtitle {
                            translate(TL.CodeScanning.CREATE_NOT_ALLOWED)
                        }
                    }
                    // Next Button
                    twPrimaryButton(
                        text = TL.General.CREATE,
                        disabledFlow = apiUserStore.data.map { it.isAnonymous },
                    ) {
                        clicks handledBy {
                            activeObjectStore.prefillTitleWithCode(Unit)
                            routerStore.validateInternalRoute(mapOf("add" to ObjectType.ObjectMarker.name))
                            closeModal(Unit)
                        }
                    }
                }
            }
        }
    }
}
